






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { BrandAddress } from '@/api/braendz';
import { AccountInfo } from "@azure/msal-browser";
import { Delta } from '@/models/Delta';
import DeltaValueField from '@/components/Fields/DeltaValueField.vue';

@Component({
    components: {
        DeltaValueField
    }
})
export default class BrandDetailsAddressField extends Vue {

    // Properties
    @Prop({ required: true })
    public title!: string;

    @Prop({ required: false })
    public value?: BrandAddress | null | undefined;

    @Prop({ required: false })
    public width?: number;

    @Prop({ required: false, type: Boolean, default: true })
    public loginRequired?: boolean;

    @Prop({ required: false })
    public delta?: Delta;

    @Prop({ required: false, default: 'text' })
    public deltaType!: 'text' | 'chip';

    @Prop({ required: false, default: true })
    public deltaTooltipBottom!: boolean;

    // Getter
    public get userAccount(): AccountInfo | null {
        return this.$store.state.userAccount;
    }
}
